"use strict";exports.__esModule = true;exports.default = void 0;var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}
var MAX_PAGES = 9;
var MIN_PAGES = 3;var _default =

{
  /**
   * Handle normal mouse click for item, next page and previous page respectively.
   * @param {MouseEvent} originalEvent
   */
  handlePageNumberClick(index, originalEvent, el) {
    this.emit('select', {
      el,
      originalEvent,
      value: el.innerText,
      index });

  },

  handleNextPageClick(originalEvent, el) {
    if (!el.hasAttribute('aria-disabled')) {
      this.emit('next', {
        el,
        originalEvent });

    }
  },

  handlePreviousPageClick(originalEvent, el) {
    if (!el.hasAttribute('aria-disabled')) {
      this.emit('previous', {
        el,
        originalEvent });

    }
  },

  onCreate() {
    this.state = { maxItems: 0 };
  },

  onMount() {
    this._calculateMaxItems();
    this.subscribeTo(eventUtils.resizeUtil).on('resize', this._calculateMaxItems.bind(this));
  },

  getItemTag(item) {
    if (item.variant) {
      return item.variant === 'link' ? 'a' : 'button';
    }
    return !!item.href ? 'a' : 'button';
  },

  /**
   * Calculates the start and end offsets given the current maximum items
   * that can be displayed.
   */
  _getVisibleRange(items) {
    var { state, input } = this;
    var { maxItems } = state;
    var { variant } = input;
    var hasDots = variant === 'show-last';
    var lastIndex = items.length - 1;
    var dotsIndex = hasDots ? lastIndex : -1;
    var hideDots = false;

    if (!maxItems) {
      return { start: 0, end: lastIndex, hideDots: true, dotsIndex };
    }

    var i = items.findIndex((item) => item.current);
    var range = Math.floor(maxItems / 2);
    var start = i - range;
    var end = i + range;

    if (start <= 0) {
      end = maxItems - 1;
      start = 0;
    } else if (end >= lastIndex) {
      end = lastIndex;
      start = lastIndex - (maxItems - 1);
    } else if (maxItems % 2 === 0) {
      start++;
    }

    if (hasDots) {
      if (i + range >= lastIndex) {
        hideDots = true;
      } else if (i <= end - 2) {
        end -= 2;
      } else {
        start += 1;
        end -= 1;
      }
    }

    return { start, end, hideDots, dotsIndex };
  },

  _calculateMaxItems() {
    var { input, state } = this;
    var items = input.items || [];

    if (!items.some((item) => !item.type)) {
      return;
    }

    var itemContainer = this.getEl('items');
    var itemWidth =
    this._itemWidth || ( // Cache the item width since it should be static.
    this._itemWidth = itemContainer.firstElementChild.offsetWidth);

    state.maxItems = Math.max(
    MIN_PAGES,
    Math.min(MAX_PAGES, Math.floor(getMaxWidth(itemContainer) / itemWidth)));

  } };


/**
 * Calculates the maximum width for an element within its container.
 * Works my making the element as large as possible, reading its width,
 * and then restoring its original width.
 *
 * @param {HTMLElement} el the element to get the max width for
 * @return {number}
 */exports.default = _default;
function getMaxWidth(el) {
  el.style.width = '100vw';
  var result = el.offsetWidth;
  el.style.width = null;
  return result;
}module.exports = exports.default;